import {createRouter, createWebHashHistory} from 'vue-router';
import App from "@/App";
import {useEndpointStore} from "@/store/endpointStore";

const routes = [
    {
        path: '/',
        component: App,
        children: [
            {
                path: '/',
                name: 'esmo',
                beforeEnter() {
                    location.href = 'https://www.esmo.org'
                }
            },
            {
                path: '/quick-contact-creation',
                name: 'quick-contact-creation',
                beforeEnter() {
                    location.href = 'https://www.esmo.org/my-esmo/abstract-contact-creation'
                }
            },
            {
                path: '/membership-exit-survey',
                name: 'membership-exit-survey',
                component: () => import('./components/MembershipExitSurvey.vue'),
                meta: {
                    apiKey: "8d60bcc3-9d8f-4b19-bb4b-4a8322aa1393"
                }
            },
            {
                path: '/quick-journalist-creation',
                name: 'quick-journalist-creation',
                component: () => import('./components/JournalistCreation.vue'),
                meta: {
                    apiKey: "7a1efa80-51c4-4adb-8d08-387af6c8592d"
                }
            },
            {
                path: '/research-project',
                name: 'research-project',
                component: () => import('./components/researchProject/ResearchProjectForm.vue')
            },
            {
                path: '/research-projects',
                name: 'research-projects',
                component: () => import('./components/researchProject/ResearchProjects.vue')
            }
        ]
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior() {
        return {left: 0, top: 0};
    }
});

router.beforeEach(function (to, from, next) {
    window.scrollTo(0, 0);
    if (to.matched.some(record => record.meta.apiKey != null)) {
        const  endpointStore =  useEndpointStore();
        endpointStore.setApiKey(to.meta.apiKey)
    }
    next()
});

export default router;